import React from 'react';
import ThemeProvider from 'threads5/themes/theme-provider';

import '../scss/vendor/_reset.scss';
import '../scss/app.scss';

import { ConsentManager } from 'src/containers/ConsentManager';
import { useCookies } from 'src/hooks';
import theme from 'src/components-v2/theme';
import { AnalyticsProvider, FormOutageNoticeProvider } from 'src/contexts';
import { ForeignContentNotificationProvider } from 'src/components/Feedback/ForeignContentNotification/ForeignContentNotification';
import { isProduction, isStaticBuild } from 'src/lib/env-constants';
import {
  FORM_OUTAGE_NOTICE_ENTRY_ID,
  fetchFormOutageNoticeById,
} from 'src/lib/fetch-form-outage-notice';

const PlaidApp = (props) => {
  const { Component, pageProps, router, err } = props;

  useCookies();

  if (Component.layout) {
    //  for Docs only (only Docs have layout)
    const Layout = Component.layout;
    return (
      <AnalyticsProvider>
        <div className='docs'>
          <Layout {...props} pathname={router.pathname} />
        </div>
        <ConsentManager />
      </AnalyticsProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <FormOutageNoticeProvider
        formOutageNotice={pageProps.formOutageNotice || null}
        // Forms only show the notice in production, so only it loads one.
        loadInBrowser={!isStaticBuild && isProduction}
      >
        <ForeignContentNotificationProvider>
          <Component {...pageProps} err={err} />
        </ForeignContentNotificationProvider>
      </FormOutageNoticeProvider>
    </ThemeProvider>
  );
};

PlaidApp.displayName = 'App';

// Static exports bake the notice into every page, so publishing it redeploys
// the site. On Node, an App getInitialProps makes every page render per
// request instead of prebuilding, so there forms load the notice in the browser.
if (isStaticBuild) {
  PlaidApp.getInitialProps = async (appContext) => {
    // Skip fetching for docs pages (they have their own layout and don't use this data)
    const isDocsPage = appContext.Component.layout !== undefined;

    if (isDocsPage) {
      return { pageProps: {} };
    }

    // Only fetch for non-docs pages
    const formOutageNotice = await fetchFormOutageNoticeById(
      FORM_OUTAGE_NOTICE_ENTRY_ID,
    );

    return {
      pageProps: {
        formOutageNotice,
      },
    };
  };
}

export default PlaidApp;
